import React from 'react'
import { Table, Space, Button, Tooltip, theme } from 'antd'
import { EditOutlined, BellOutlined, SwapOutlined, UserOutlined } from '@ant-design/icons'
import { getStatusBadge, formatPatientInfo, getTimeRemaining, formatTimeRemaining } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const BedTable = ({ bedsData, showAssignModal, showTransferModal }) => {
  const { token } = theme.useToken()

  const columns = [
    {
      title: 'Bed ID',
      dataIndex: 'bedId',
      key: 'bedId',
      sorter: (a, b) => a.bedId.localeCompare(b.bedId)
    },
    {
      title: 'Ward',
      dataIndex: 'ward',
      key: 'ward',
      sorter: (a, b) => a.ward.localeCompare(b.ward)
    },
    {
      title: 'Room',
      dataIndex: 'roomNumber',
      key: 'roomNumber',
      sorter: (a, b) => a.roomNumber.localeCompare(b.roomNumber)
    },
    {
      title: 'Status',
      dataIndex: 'bedStatus',
      key: 'bedStatus',
      render: (status) => getStatusBadge(status),
      sorter: (a, b) => a.bedStatus.localeCompare(b.bedStatus)
    },
    {
      title: 'Patient',
      dataIndex: 'patientAssigned',
      key: 'patientAssigned',
      render: (patient, record) => formatPatientInfo(patient, record.patientId)
    },
    {
      title: 'Bed Type',
      dataIndex: 'bedType',
      key: 'bedType'
    },
    {
      title: 'Time Remaining',
      key: 'timeRemaining',
      render: (_, record) => formatTimeRemaining(getTimeRemaining(record))
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          {record.bedStatus === 'Available' && (
            <Tooltip title='Assign Patient'>
              <Button
                icon={<UserOutlined style={{ color: token.colorPrimary }} />}
                size='small'
                onClick={() => showAssignModal(record)}
                style={{
                  background: hexToRGBA(token.colorPrimary, 0.1),
                  borderColor: token.colorPrimary
                }}
              />
            </Tooltip>
          )}
          {record.bedStatus === 'Occupied' && (
            <>
              <Tooltip title='Transfer Patient'>
                <Button
                  icon={<SwapOutlined style={{ color: token.colorWarning }} />}
                  size='small'
                  onClick={() => showTransferModal(record)}
                  style={{
                    background: hexToRGBA(token.colorWarning, 0.1),
                    borderColor: token.colorWarning
                  }}
                />
              </Tooltip>
              <Tooltip title='Discharge Planning'>
                <Button
                  icon={<BellOutlined style={{ fontSize: '16px', color: token.colorInfo }} />}
                  size='small'
                  style={{
                    background: hexToRGBA(token.colorInfo, 0.1),
                    borderColor: token.colorInfo
                  }}
                />
              </Tooltip>
            </>
          )}
          <Tooltip title='Edit Bed Info'>
            <Button
              icon={<EditOutlined style={{ color: token.colorSuccess }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorSuccess, 0.1),
                borderColor: token.colorSuccess
              }}
            />
          </Tooltip>
        </Space>
      )
    }
  ]

  return <Table columns={columns} dataSource={bedsData} rowKey='bedId' pagination={{ pageSize: 10 }} />
}

export default BedTable
